<template>
  <div>
    <div class="container">
      <el-table
        :data="tableData"
        border
        class="table"
        ref="multipleTable"
        header-cell-class-name="table-header"
        v-loading="loading"
      >
        <el-table-column prop="name" label="名称" align="center"></el-table-column>
        <el-table-column prop="url" label="地址" align="center"></el-table-column>
        <!-- <el-table-column prop="path" label="路径" align="center"></el-table-column> -->
        <el-table-column label="操作" width="200" align="center">
          <template slot-scope="scope">
            <el-button type="text" @click="changerow(scope.row)">修改</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-dialog
      :visible.sync="lookVisible"
      width="60%"
      :close-on-click-modal="false"
      @close="close_info"
    >
      <p class="info_title">{{iteminfo.name}}</p>
      <tinymce-editor ref="editor" v-model="content" :disabled="disabled"></tinymce-editor>
      <span slot="footer" class="dialog-footer self-dialog-footer">
        <el-button type="primary" @click="postEdit">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import http from "../../../api/hemeraApiConfig";
import TinymceEditor from "./Editor_config";
export default {
  name: "Doctorlist",
  data() {
    return {
      tableData: [],
      keywords: "",
      loading: false,
      lookVisible: false,
      content: "",
      disabled: false,
      iteminfo: {},
    };
  },
  components: {
    TinymceEditor,
  },
  created() {
    this.getData();
  },
  methods: {
    // 鼠标单击的事件
    onClick(e, editor) {
      // console.log('Element clicked')
      console.log(e);
      console.log(editor);
    },
    // 清空内容
    clear() {
      this.$refs.editor.clear();
    },
    getData() {
      let that = this;
      that.loading = true;
      http.get("admin/protocol").then(function (res) {
        // console.log(res);
        that.tableData = res.data.data;
        that.loading = false;
      });
    },
    //选择
    selectHandle() {
      this.currentPage = 1;
      this.getData();
    },
    // 触发搜索按钮
    handleSearch() {
      this.currentPage = 1;
      this.getData();
    },
    // 删除操作
    handleDelete(row) {
      let that = this;
      // 二次确认删除
      that
        .$confirm("确定要删除吗？", "提示", {
          type: "warning",
        })
        .then(() => {
          http.delete("admin/messages/" + row.id).then(function (res) {
            // console.log(res);
            if (res.data.status_code == 200) {
              that.$message.success("删除成功");
              that.getData();
            }
          });
        })
        .catch(() => {});
    },
    changerow(item) {
      let that = this;
      // console.log(item)
      this.lookVisible = true;
      // this.iteminfo()
      let url = "admin/protocol/" + item.type;
      http.get(url).then(function (res) {
        console.log(res);
        if (res.data.status_code == 200) {
          that.iteminfo = res.data.data;
          that.content = res.data.data.content;
          that.iteminfo["type"] = item.type;
          // console.log(that.content)
        }
      });
    },
    updateData(e = "") {
      this.content = e;
      // console.info(e);
    },
    close_info() {
      this.content = "";
      this.iteminfo = {
        content: "",
        type: 0,
        path: "",
        url: "",
        name: "",
      };
      // console.log(this.iteminfo)
    },
    postEdit() {
      let that = this;
      // console.log(this.content)
      // if(this.content.indexOf("script")>-1){

      // }
      // console.log(this.content.indexOf("<script"))
      // console.log(this.content.split("script"))
      // let content1 = '<script src="https://cdn.bootcdn.net/ajax/libs/jquery/3.5.1/jquery.min.js"><'+'/script>	<script type="text/javascript"><'+'/script>'
      let content1 = '<script src="https://cdn.bootcdn.net/ajax/libs/jquery/3.5.1/jquery.min.js"><'+'/script>	<script type="text/javascript">window.onload=function(){$("img").each(function(index){var me=$(this);var img_path=me.attr("src");$(this).css("max-width","100%");var issrc=img_path.indexOf("//image.haiweikexin.com");if(issrc>-1){var star=img_path.indexOf("common/editor/");var end=img_path.indexOf("?");var path=img_path.substring(star,end);var param={work_path:path,end_point:"oss-cn-hangzhou.aliyuncs.com",bucket:"family-tcm"};$.ajax({type:"GET",async:false,contentType:"application/json;charset=UTF-8",url:"https://api.ss.jiankanghao.net/api/v1/info",data:param,success:function(data){if(data.status_code==200){me.attr("src",data.data.url)}}})}})};<'+'/script>'
      // let content2 = '<p style="text-align: justify; font-size: 14px; color: #262626; line-height: 1.74; letter-spacing: 0.05em; outline-style: none; overflow-wrap: break-word; margin: 0px;" data-lake-id="f3230113dcff64f83b40de755a91fc19"><img src="https://image.haiweikexin.com/common/editor/default.png?Expires=1597118789&amp;OSSAccessKeyId=LTAI4FtMEMkbH2Ydtom5XQsv&amp;Signature=bteRLqiByv%2BTQVzaiTkFBKqn6Uo%3D" alt="agimg" width="1920" height="1080"></p>' + content1;
      // console.log(content2);

      let content2 = '';
      let hascontent = this.content.indexOf("<script")
      if(hascontent>-1){
        content2 = this.content
      }else{
        content2 = this.content + content1
      }
      let url = "admin/protocol/" + this.iteminfo.type;
      let params = {
        name: this.iteminfo.name,
        content: content2
      };
      http.put(url, params).then(function (res) {
        // console.log(res)
        if (res.data.status_code == 200) {
          that.$message.success("修改成功");
          that.lookVisible = false;
          that.iteminfo = {};
          that.getData();
        }
      });
    },
  },
};
</script>

<style scoped>
.info_title {
  font-size: 18px;
}
.handle-box {
  margin-bottom: 20px;
}

.handle-select {
  width: 120px;
}

.handle-input {
  width: 300px;
  display: inline-block;
}
.table {
  width: 100%;
  font-size: 14px;
}
.red {
  color: #ff0000;
}
.mr10 {
  margin-right: 10px;
}
.table-td-thumb {
  display: block;
  margin: auto;
  width: 40px;
  height: 40px;
}
.self-dialog-footer {
  display: block;
  text-align: center;
}
</style>
